import apiClient from './client'

export interface QuestionOption {
  id: string
  text: string
}

export interface Question {
  question_id: string
  statement: string
  options: QuestionOption[]
  status: 'draft' | 'live' | 'archived'
  created_by: string
  created_at: string
  updated_at: string
}

export interface Vote {
  question_id: string
  user_id: string
  option_id: string
  created_at: string
  updated_at: string
}

export interface VoteResults {
  question_id: string
  total_votes: number
  results: Record<string, number>
}

export const getLiveQuestion = async (): Promise<Question> => {
  return apiClient.get<Question>('/questions/live')
}

export const getMyVote = async (questionId: string): Promise<Vote> => {
  return apiClient.get<Vote>(`/questions/${questionId}/my-vote`)
}

export const getVoteResults = async (questionId: string): Promise<VoteResults> => {
  return apiClient.get<VoteResults>(`/questions/${questionId}/results`)
}

export const castVote = async (questionId: string, optionId: string): Promise<Vote> => {
  return apiClient.post<Vote>(`/questions/${questionId}/vote`, { optionId })
}
